/** 来源：crm/foodbuy/market Badge；采用可透传 span 属性的公共签名与五种语义 tone。 */
import type { HTMLAttributes, ReactNode } from 'react'
import { badgeToneClasses, type Tone } from './tones'

export type BadgeTone = Tone

export type BadgeProps = HTMLAttributes<HTMLSpanElement> & { tone?: Tone; dot?: boolean; children: ReactNode }

export function Badge({ tone = 'neutral', dot = false, className = '', children, ...props }: BadgeProps) {
  return (
    <span
      className={`inline-flex items-center gap-1 self-start whitespace-nowrap rounded-[var(--radius-pill)] px-2 py-0.5 text-[11px] font-semibold leading-4 ${badgeToneClasses[tone]} ${className}`.trim()}
      {...props}
    >
      {dot ? <span className="h-1.5 w-1.5 rounded-[var(--radius-pill)] bg-current" aria-hidden="true" /> : null}
      {children}
    </span>
  )
}
